function initMaierModal() {
    document.querySelectorAll('.maier-modal-popup').forEach(function (popup) {
        let modal = new Modal({
            id: popup.id,
            maximumDisplayTimes: popup.getAttribute('data-maximum-display-times'),
            excludedAutoCloseSelectors: ['#onetrust-consent-sdk']
        });

        modal.show();
    })
}

function setupMaierModal() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            initMaierModal();
        })
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMaierModal);
} else {
    setupMaierModal();
}